import { render, staticRenderFns } from "./CosmetRegister.vue?vue&type=template&id=66ce44fa&scoped=true&"
import script from "./CosmetRegister.vue?vue&type=script&lang=js&"
export * from "./CosmetRegister.vue?vue&type=script&lang=js&"
import style0 from "./CosmetRegister.vue?vue&type=style&index=0&id=66ce44fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce44fa",
  null
  
)

export default component.exports